module.exports = __webpack_public_path__ + "static/media/Greenock-Hills-bylaws.9148808a.pdf";